import * as React from 'react';
import { SVGProps } from 'react';

const IconIncidentSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m8 0 1.276 5.351L16 2l-4.5 5.346L15 8.5 11 10l1 6-4-5.06-2.866 2.56V10L0 9.5l4.5-2.154-2-3.846 4 1L8 0Z" />
  </svg>
);
export default IconIncidentSizeS;
